// src/com/login/AppLogin.js
import React, { useState, useEffect } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import HomeplusBigLogo from '../../asset/image/homeplus.svg';
import { useMutation} from '@apollo/client';
import { useSnackbar } from 'notistack';
import { ApiMsg, AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { AppLoginDict } from './AppLoginDict';
import { LOGIN_NEW_TOP } from './AppLoginGql';
import UserSessionInfo from '../../value/UserSessionInfo';
import VzmTextField from '../../common/VzmTextField';
import InputUtil from '../../value/InputUtil';
import { NonCapButton } from '../../common/TopStyle';


const LogoBox = styled(Box)({marginBottom: '1rem', display:'flex', alignItems:'center', flexDirection:'column'});

const TopText = styled(Box)({
    fontSize: '4vw', fontWeight: 'bold', fontFamily: 'Times New Roman', fontStyle: 'italic',
});

const LoginBox = styled(Box)({padding:'0 5% 0 5%'});
const inputMap = AppLoginDict.inputMap;


const DevBox = styled(Box)({
    position: 'fixed', bottom: 50, left: 20, right: 20, padding: 5, // backgroundColor: '#fdd',
    borderRadius: 5, border: '1px solid #f00', textAlign: 'center', 
});

/*
home1	1	981	관리자	4321	안성FDC	신선
hds1104	1	982	한대선	hds2657	안성ADC	상온
jhan526	2	904	안주호	ajh3281!	함안FDC	신선
hana1805	3	910	주환엽	hana8287	Exp.함안	Express
hmn00	6	916	함안ADC	asdf123	함안ADC(가상)
jkh7738	6	015	조규호	whrbgh76	영통점
hmnklp1	7	2020031002	송영진	111111	한국로지스풀-함안FDC
system24	9	910	한형수	111111	Exp.함안	Express
*/

const TestUsers = [
    {id: 'home1', ps: '4321', authCd: '1', dcCd: '981', dc: '안성FDC'},
    {id: 'hds1104', ps: 'hds2657', authCd: '1', dcCd: '982', dc: '안성ADC'},
    {id: 'jhan526', ps: 'ajh3281!', authCd: '2', dcCd: '904', dc: '함안FDC'},
    {id: 'hana1805', ps: 'hana8287', authCd: '3', dcCd: '910', dc: 'Exp.함안'},
    {id: 'hmn00', ps: 'asdf123', authCd: '6', dcCd: '916', dc: '함안ADC(가상)'},
    {id: 'jkh7738', ps: 'whrbgh76', authCd: '6', dcCd: '015', dc: '영통점'},
    {id: 'hmnklp1', ps: '111111', authCd: '7', dcCd: '2020031002', dc: '한국로지스풀-함안FDC'},
    {id: 'system24', ps: '111111', authCd: '9', dcCd: '910', dc: 'Exp.함안'},
];


/**
 * 로그인 화면.
 * @param {*} param0 
 * @returns 
 */
export default function AppLogin({
    onLoginSuccess
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const { enqueueSnackbar } = useSnackbar();
    const isLocal = window.location.hostname === 'localhost';

    const [loginNewTop, responseLogin] = useMutation(LOGIN_NEW_TOP, {
        onCompleted: (data) => {onCompleteLogin(data)},
        onError: (error) => alert(error.message),
    });

    const onChangeValue = (id, value, error) => {
        setInput(InputUtil.reflectData(input, id, value, error, inputMap, false));
    };

    const onClickDevSetUser = (id, pswd) => {
        const newInput = {...input};
        newInput.data.userId = id;
        newInput.data.password = pswd;
        newInput.changed = true;
        setInput(newInput);
    };

    const onCompleteLogin = (data) => {
        if(data.loginNewTop) {
            if(data.loginNewTop.sessionNote === ApiMsg.OK) {
                const sessionInfo = UserSessionInfo.initFromUserObject(data.loginNewTop);
                // userInfoRepo(sessionInfo);
                enqueueSnackbar(sessionInfo.user.userName + '님 환영합니다.', {variant: 'success'});
                onLoginSuccess(sessionInfo);
            }
            else {
                alert('로그인 실패: ' + data.loginNewTop.sessionNote);
            }
        }
    };

    const onClickLogin = () => {
        if(!input.data.userId) {
            alert('아이디를 입력하세요.');
            return;
        }
        if(!input.data.password) {
            alert('사용자암호를 입력하세요.');
            return;
        }

        const goOn = window.confirm('휴대전화 접속 시 사용요금제에 따라 추가요금이 발생할 수 있습니다. 계속하시겠습니까?');

        if(goOn) {
            const param = {variables: {userId: input.data.userId, password: input.data.password}};
            /* const newInput = {...input};
            newInput.data.password = '';
            setInput(newInput); */
            loginNewTop(param);
        }
    };

    const onClickLogoIfDev = () => {
        const isDev = window.location.href.indexOf('localhost') > 0;
        if(isDev) {
            const newInput = {...input};
            newInput.data.userId = 'home1';
            newInput.data.password = '4321';
            setInput(newInput);
        }
    }

    const renderTOP = () => {
        return(
            <TopText>
                <span style={{color:"red"}}>T</span>ransport &nbsp;
                <span style={{color:"orange"}}>O</span>peration &nbsp;
                <span style={{color:"green"}}>P</span>rogram
            </TopText>
        );
    };

    return(
        <Box style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', flexDirection:'column'}}>
            <LogoBox>
                <img src={HomeplusBigLogo} alt="Homeplus"
                    onClick={onClickLogoIfDev}
                    style={{width:'60%',}}
                />
                {renderTOP()}
            </LogoBox>
            <LoginBox>
                <VzmTextField dict={inputMap.userId}
                    value={input.data.userId}
                    onChange={onChangeValue}
                    fullWidth={true}
                    inputProps={{autoComplete:"userId"}}
                    style={{marginBottom: '1rem'}}
                />
                <VzmTextField dict={inputMap.password}
                    value={input.data.password}
                    onChange={onChangeValue}
                    onEnterKey={()=>{if(input.data.password) onClickLogin()}}
                    fullWidth={true}
                    inputProps={{autoComplete: 'current-password'}}
                    style={{marginBottom: '1rem'}}
                />
                <Button variant={AppStyle.mui.contained} color={AppStyle.mui.primary}
                    size={AppWord.LARGE}
                    onClick={onClickLogin}
                    startIcon={<LoginIcon/>}
                    fullWidth
                    disabled={responseLogin.loading}
                >
                    로그인
                </Button>
            </LoginBox>
            {
                isLocal &&
                <DevBox>
                    {
                        Array.from({length: 10}).map((_, idx) => {
                            return(
                                <NonCapButton
                                    key={idx}
                                    onClick={()=>onClickDevSetUser('etrace'+(idx), 'home+400')}
                                    variant='contained'
                                    color={
                                        idx >= 6 && idx <= 8 ?
                                        AppStyle.mui.inherit :
                                        AppStyle.mui.warning
                                    }
                                    style={{marginLeft: 5, marginBottom: 5}}
                                    title={'etrace'+(idx)}
                                >
                                    e.{idx} {idx===6 ? 'st' : idx===7 ? 'tr' : idx===8 ? 'dr' : null}
                                </NonCapButton>
                            )
                        })
                    }
                    {
                        TestUsers.map((user) => {
                            return(
                                <NonCapButton
                                    key={user.id}
                                    onClick={()=>onClickDevSetUser(user.id, user.ps)}
                                    variant='contained'
                                    color={AppStyle.mui.warning}
                                    style={{marginLeft: 5, marginBottom: 5}}
                                    title={user.dcCd + ' ' + user.dc + ' ' + user.authCd}
                                >
                                    {user.id} ({user.authCd})
                                </NonCapButton>
                            )
                        })
                    }
                </DevBox>
            }
        </Box>
    );
}

/*


home1	1	981	관리자	4321	안성FDC	신선
hds1104	1	982	한대선	hds2657	안성ADC	상온
jhan526	2	904	안주호	ajh3281!	함안FDC	신선
hana1805	3	910	주환엽	hana8287	Exp.함안	Express
hmn00	6	916	함안ADC	asdf123	함안ADC(가상)
jkh7738	6	015	조규호	whrbgh76	영통점
hmnklp1	7	2020031002	송영진	111111	한국로지스풀-함안FDC
system24	9	910	한형수	111111	Exp.함안	Express

*/
